import { useAuthStore } from '../../../stores/authStore';
import { MarketingSection } from '../../../components/settings/MarketingSection';
import { SettingsSubPage } from '../components/SettingsSubPage';

export function MarketingPage() {
  const authBusiness = useAuthStore(s => s.business);

  return (
    <SettingsSubPage title="Marketing" description="Visit recency, birthday, no-show campaigns">
      <MarketingSection businessId={authBusiness?.id} tier={authBusiness?.tier ?? 'free'} />
    </SettingsSubPage>
  );
}
